export const config = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8080',
  oauthClientId:
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    '502318394743-8fnlpni61hjetivmsq4pa4q78q9rqk4g.apps.googleusercontent.com',
  tokenStorageKey: 'infiops_token',
  pollIntervalMs: 60_000,
} as const;
